import { render } from "./SumupView.vue?vue&type=template&id=7713a982"
import script from "./SumupView.vue?vue&type=script&lang=js"
export * from "./SumupView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__